import {useLocation, useNavigate} from 'react-router-dom';
import CustomHeader from '../../../../../../components/mazraeKit/headers/homeHeader';
import MainFooter from '../../../../../../components/mazraeKit/footers/footerMain';
import BrandCard from './BrandCard';
import Button from '../../../../../../components/button';
import useGetListBrandOwner from '../../../../../../services/hookService/getListBrandOwner/useGetListBrandOwner';
import DotsLoading from '../../../../../../components/dotsLoading';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {useEffect, useState} from 'react';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {sortByStatus} from '../../../../../../utilities/helper/sortByStatus';

const MyStoreBrandsPage = () => {
  const navigate = useNavigate();
  const {data: myBrands, isLoading} = useGetListBrandOwner();
  const {state} = useLocation() as {state: ICreateBrandResponse};

  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    if (state && !hasShown) {
      setIsOpen(true);
      setHasShown(true);
    }
  }, [state, hasShown]);

  const [isOpenLimit, setIsOpenLimit] = useState(false);

  const addBrandHandler = () => {
    if (!myBrands) return;

    const pendingBrands = myBrands.filter(brand => brand.status === 'pending');

    // Check if user has too many pending brands before navigation
    if (pendingBrands.length >= 1) {
      setIsOpenLimit(true);
      return;
    }

    navigate('/create-brand');
  };

  return (
    <div className="flex relative flex-col w-full h-screen">
      <div>
        <CustomHeader
          canScroll={true}
          title="برندها"
          preIcon="icon-nameArrow---Right"
          isActiveRightIcon
          onClick={() => navigate('/my-store-info')}
        />
      </div>

      <div className="flex overflow-y-auto flex-col gap-3 p-4 mb-10 w-full">
        <p className="leading-6 text-justify text-gray-800 text-md">
          با ثبت برند هویت خود را از رقبا متمایز کنید. این تمایز به محصول و شبکه
          فروش شما منتقل می‌شود و به کشاورزان در انتخاب و تصمیم‌گیری بهتر کمک
          می‌کند.
        </p>

        <div className="mb-20 space-y-3">
          {isLoading && <DotsLoading />}

          {myBrands &&
            myBrands.length > 0 &&
            myBrands
              .sort((a, b) => sortByStatus(a, b))
              .map(item => (
                <BrandCard
                  key={item.id}
                  logo={item.logo}
                  name={item.name}
                  data={item}
                />
              ))}
        </div>

        {/* Created Brand Bottom Sheet ----------------------------------------- */}

        <BottomSheet
          onDismiss={() => setIsOpen(false)}
          open={isOpen}
          className="custom-bottom-sheet"
        >
          <div className="flex relative flex-col justify-between items-center px-8 pb-6 mt-3">
            <SpanIcon
              className="absolute top-5 left-7 text-2xl icon-nameClose-remove"
              onClick={() => {
                setIsOpen(false);
                navigate(location.pathname, {replace: true, state: undefined});
              }}
            />
            <i className="mt-3 text-4xl icon-size2489 text-farm-shop-500" />
            <span className="text-lg font-Medium">ثبت برند</span>

            <p className="my-7 text-justify text-md">
              برند شما پس از بررسی توسط کارشناسان، فعال می‌شود. می‌توانید برای
              تسریع فرآیند، محصولات برندتان را اضافه کنید.
            </p>

            <button
              onClick={() =>
                navigate(state && `/create-brand/${state.id}/add-product`)
              }
              className="flex justify-center items-center py-4 w-full h-12 text-white rounded-lg border-0 bg-farm-shop-500"
            >
              افزودن محصولات برند
            </button>
          </div>
        </BottomSheet>

        {/* Brand Limit Bottom Sheet ----------------------------------------- */}

        <BottomSheet
          onDismiss={() => setIsOpenLimit(false)}
          open={isOpenLimit}
          className="custom-bottom-sheet"
        >
          <div className="flex relative flex-col justify-between items-center px-8 pb-6 mt-3">
            <SpanIcon
              className="absolute top-5 left-7 text-2xl icon-nameClose-remove"
              onClick={() => {
                setIsOpenLimit(false);
              }}
            />
            <i className="mt-3 text-4xl icon-size2489 text-farm-shop-500" />
            <span className="text-lg font-Medium">در انتظار تایید برند</span>

            <p className="my-7 text-justify text-md">
              شما یک درخواست ثبت برند در انتظار تایید دارید. بعد از تعیین وضعیت
              آن، می‌توانید درخواست جدید ثبت کنید.
            </p>

            <button
              onClick={() => setIsOpenLimit(false)}
              className="flex justify-center items-center py-4 w-full h-12 text-white rounded-lg border-0 bg-farm-shop-500"
            >
              متوجه شدم
            </button>
          </div>
        </BottomSheet>

        <Button
          onClick={addBrandHandler}
          className="fixed right-4 left-4 bottom-20"
        >
          افزودن برند
        </Button>
      </div>

      <div className="fixed right-0 bottom-0 left-0">
        <MainFooter />
      </div>
    </div>
  );
};

export default MyStoreBrandsPage;
